import { createSelector } from 'reselect';

import getAllDocuments from '../layers/getAllDocuments';

const getAllDocumentTransforms = createSelector([getAllDocuments], (documents) =>
    documents.map((doc) => doc.transforms).reduce((acc, arr) => acc.concat(arr), []),
);

export default getAllDocumentTransforms;
